import { consts } from './constants'
import { messageComponent } from './components/message/message'
import { timelineComponent } from './components/timeline/timeline'
import { playerComponent } from './components/player/player'
import { playerComponent2 } from './components/player2/player'
import { svgComponent } from './components/svg/svg'
import { actionbarComponent } from './components/actionbar/actionbar'
import { datepickerComponent } from './components/datepicker/datepicker'
import { modalDialog } from './components/modalDialog/index'
import { menuComponent } from './components/menu/menu'
import { switcher } from './components/switcher/index'
import { toggle } from './components/toggle/index'
import { videoGridMockComponent } from './components/videoGridMock/index'
import * as dayjsLocaleRu from './dayjs-locale-ru'
import { pageDevices } from './pages/devices/index'
import { pagePlayback } from './pages/playback/index'
import { pageCamera } from './pages/camera/index'
import { pageDevice } from './pages/device/index'
import { pageAbout } from './pages/about/about'
import { pageLog } from './pages/log/log'
import { pageMessage } from './pages/message/message'
import { pageChangePassword } from './pages/change-password/change-password'
import { pageCinema } from './pages/cinema/index'
import { pageCinema2 } from './pages/cinema2/index'
import { pageCinemaEdit } from './pages/cinema-edit/index'
import { pageSettings } from './pages/settings/index'
import { pageLogin } from './pages/login/index'
import { fapp } from './fapp'

dayjs.extend(dayjs_plugin_customParseFormat)
dayjs.locale('ru')

/**
 * Функция для парсинга строки в объект, автоматически определяя тип данных.
 * @param {string} input - Строка для парсинга.
 * @returns {Object} - Объект с parsed значениями или ошибка.
 */
function parseStringToObject(input) {
    // Разбиваем строку на части по ':'
    const [typePart, valuesPart] = input.split(':').map(part => part.trim());
    
    // Определяем тип данных
    const type = typePart.split(' ')[0];
    if (type == '(null)') return null
    
    // Удаляем фигурные скобки и пробелы
    const valuesString = valuesPart.replace(/[{}]/g, '').trim();
    const values = valuesString.split(',').map(value => parseInt(value.trim(), 10));
    
    let result = { type };
  
    switch (type) {
      case 'UIEdgeInsets':
        if (values.length === 4) {
          result = {
            type: 'UIEdgeInsets',
            top: values[0],
            left: values[1],
            bottom: values[2],
            right: values[3]
          };
        } else {
          throw new Error("Неверное количество значений для UIEdgeInsets");
        }
        break;
  
      case 'CGSize':
        if (values.length === 2) {
          result = {
            type: 'CGSize',
            width: values[0],
            height: values[1]
          };
        } else {
          throw new Error("Неверное количество значений для CGSize");
        }
        break;
  
      case 'CGRect':
      case 'NSRect':
        if (values.length === 4) {
          result = {
            type: 'CGRect',
            x: values[0],
            y: values[1],
            width: values[2],
            height: values[3]
          };
        } else {
          throw new Error("Неверное количество значений для CGRect");
        }
        break;
  
      default:
        throw new Error("Неизвестный формат данных");
    }
  
    return result;
}

let targetIndex = 0

async function showDeepObjects(name, root = '') {
    window._modules.ipc.request('nb_call_main_thread', { object: 'nb', method: 'setProperty:propertyName:value:', 'args': 'o='+name+'|s=backgroundColor|o=clearColor' })
    window._modules.ipc.request('nb_call_main_thread', { object: name, method: 'setOpaque:', 'args': 's=YES' })
    let resp = await window._modules.ipc.request('nb_call_main_thread', { object: 'nb', method: 'getPropertyDeep:propertyName:', 'args': 'o='+name+'|s=subviews' })
    let str = resp.data.trim().slice(1, -1).trim()
    if (str == "null" || str=='\\n') return
    console.log(root,str)
    let elements = str.split(/",\s*"/);
    for (let i = 0; i < elements.length; i++) {
        resp = await window._modules.ipc.request('nb_call_main_thread', { object: 'nb', method: 'getPropertyDeep:propertyName:', target: 'temp'+targetIndex, 'args': 'o='+name+'|s=subviews.'+i })
        const obj = 'temp'+targetIndex
        targetIndex++
        await showDeepObjects(obj, root+="\t")
    }
}

const root = _ => {
    let cbIndex = 0
    const callbacks = {}
    const pages = {
        devices: pageDevices,
        cinema: pageCinema,
        cinema2: pageCinema2,
        playback: pagePlayback,
        camera: pageCamera,
        device: pageDevice,
        about: pageAbout,
        message: pageMessage,
        changePassword: pageChangePassword,
        cinemaEdit: pageCinemaEdit,
        log: pageLog,
        settings: pageSettings,
        login: pageLogin
    }
    let events = {}
    let camerasById = {}
    let devicesById = {}
    let ipc = null

    return {
        consts,
        app: {
            version: consts.version,
            user: {},
            isLogin: false,
            showMenu: false,
            orientation: '',
            token: '',
            videoGridMock: _ => { },
            safeArea: {},
            context: {},
            components: {
                message: messageComponent,
                timeline: timelineComponent,
                player: playerComponent,
                player2: playerComponent2,
                svg: svgComponent,
                datepicker: datepickerComponent,
                actionbar: actionbarComponent,
                menu: menuComponent,
                modalDialog,
                switcher,
                toggle
            },
            pages: [],
            goPage(page, last) {
                //this.pages.shift()
                //this.pages = []
                if (!page) return
                if (this.pages.length > 0) {
                    const lastPage = this.pages[this.pages.length - 1]
                    if (lastPage.context.id == page) return
                }
                const pageFun = pages[page]()
                const orInit = pageFun.init
                const self = this
                pageFun.init = async function() {
                    await orInit.call(this)
                    if (this.navigatingTo) await this.navigatingTo()
                    if (this.activating) this.activating()
                    this.context.show = true
                    if (last && self.pages.length > 1) {
                        window._app.$nextTick(() => {
                            const lastPage = self.pages[self.pages.length - 2]
                            lastPage.context.show = false
                            if (!lastPage.transitionEffect) {
                                if (lastPage.navigatedFrom) {
                                    lastPage.navigatedFrom()
                                }
                                self.pages.shift()
                            }
                        })
                    }
                }

                const pageObj = Alpine.reactive(pageFun)
                pageObj.context = {
                    id: page,
                    class: '',
                    show: false,
                    app: this,
                    body: '',
                    //transitionReady: false,
                    onHide() { },
                    onTransition(event) {
                        //if (pageObj.context.transitionReady) return
                        //pageObj.context.transitionReady = true
                        if (pageObj.context.show) {
                            if (event.type != 'transitionend') return
                            const pages = window._app.app.pages
                            if (pageObj.navigatedTo) pageObj.navigatedTo()
                            if (pages.length > 1) {
                                const lastPage = pages[pages.length - 2]
                                if (lastPage.deactivated) lastPage.deactivated()
                                if (last) pages.shift()
                            }
                        } else {
                            if (pageObj.context.onHide) pageObj.context.onHide()
                        }
                    }
                }
                this.pages.push(pageObj)
                if (this.pages.length > 1) {
                    const lastPage = this.pages[this.pages.length - 2]
                    if (lastPage.deactivating) lastPage.deactivating()
                }
            },
            async goBack() {
                if (this.pages.length > 0) {
                    const lastPage = this.pages[this.pages.length - 1]
                    if (lastPage.navigatingFrom) lastPage.navigatingFrom()
                    lastPage.context.onHide = () => {
                        if (!lastPage._deleted) {
                            lastPage._deleted = true
                            if (lastPage.navigatedFrom) {
                                lastPage.navigatedFrom()
                            }
                            this.pages.pop()
                            if (this.pages.length == 0) {
                                window._app.callIOS('back')
                            }
                        }
                    }
                    lastPage.context.show = false
                    if (this.pages.length > 1) {
                        const beforePage = this.pages[this.pages.length - 2]
                        if (beforePage.navigatingTo) await beforePage.navigatingTo()
                        if (beforePage.activating) beforePage.activating()
                    }
                }
            },
            on(name, cb, obj) {
                if (!events[name]) events[name] = []
                events[name].push({
                    cb,
                    obj
                })
            },
            off(name, cb) {
                if (!events[name]) return
                events[name].forEach((item, i) => {
                    if (item.cb == cb) delete (events[name][i])
                })
            },
            emit(name, data) {
                if (!events[name]) return
                for (let i in events[name]) {
                    if (events[name][i].obj) {
                        events[name][i].cb.call(events[name][i].obj, data)
                    } else {
                        events[name][i].cb(data)
                    }
                }
            },
            pageExt(page) {
                if (page.transitionEffect === false) return {}
                return {
                    '@transitioncancel.debounce': page.context.onTransition,
                    '@transitionend.debounce': page.context.onTransition,
                    'x-transition:enter': 'transition ease-out duration-300',
                    'x-transition:enter-start': 'opacity-0 transform translate-x-full',
                    'x-transition:enter-end': 'opacity-100 transform translate-x-0',
                    'x-transition:leave': 'transition ease-out duration-300',
                    'x-transition:leave-start': 'opacity-100 transform translate-x-0',
                    'x-transition:leave-end': 'opacity-0 transform translate-x-full'
                }
            },
            logout() {
                fapp.logout()
            },
            getCamera(id) {
                if (camerasById[id] == undefined) return null

                return camerasById[id]
            },
            getDevice(id) {
                if (devicesById[id] == undefined) return null

                return devicesById[id]
            },
            callIOS: null
        },
        isConnected: false,
        list: [],
        async init() {
            window._app = this
            this.app.callIOS = this.callIOS

            if (window.webkit && (window.webkit.messageHandlers == undefined || window.webkit.messageHandlers.IOS == undefined)) {
                ipc = window['_modules'].ipc
                ipc.debug(true)
                await window['_modules'].extension.load('player')
                await ipc.request('nb_call_main_thread', { object: 'app', method: 'delegate', target: 'temp', 'args': '' })
                await ipc.request('nb_call_main_thread', { object: 'temp', method: 'window', target: 'window', 'args': '' })
                await ipc.request('nb_call_main_thread', { object: 'scroll', method: 'removeFromSuperview', 'args': '' }).catch(e => console.log(e))
                await ipc.request('nb_call_main_thread', { object: 'nb', method: 'getPropertyDeep:propertyName:', target: 'mainView', 'args': 'o=window|s=subviews.0.subviews.0.subviews.0' })
                await ipc.request('nb_call_main_thread', { object: 'nb', method: 'getPropertyDeep:propertyName:', target: 'webView', 'args': 'o=window|s=subviews.0' })
                await ipc.request('nb_call_main_thread', { object: 'nb', method: 'createClass:', target: 'temp', 'args': 's=UIColor' })
                await ipc.request('nb_call_main_thread', { object: 'temp', method: 'greenColor', target: 'greenColor', 'args': '' })
                await ipc.request('nb_call_main_thread', { object: 'temp', method: 'redColor', target: 'redColor', 'args': '' })
                await ipc.request('nb_call_main_thread', { object: 'temp', method: 'blackColor', target: 'blackColor', 'args': '' })
                await ipc.request('nb_call_main_thread', { object: 'temp', method: 'yellowColor', target: 'yellowColor', 'args': '' })
                await ipc.request('nb_call_main_thread', { object: 'temp', method: 'clearColor', target: 'clearColor', 'args': '' })
                showDeepObjects('mainView')
                await ipc.request('nb_call_main_thread', { object: 'nb', method: 'setProperty:propertyName:value:', 'args': 'o=webView|s=backgroundColor|o=clearColor' })
                await ipc.request('nb_call_main_thread', { object: 'webView', method: 'setOpaque:', 'args': 's=YES' })
                //await ipc.request('nb_call_main_thread', { object: 'nb', method: 'setProperty:propertyName:value:', 'args': 'o=webView|s=frame|rect={{100, 100}, {414, 896})}' })
                await ipc.request('nb_call_main_thread', { object: 'nb', method: 'createObj:', target: 'temp', 'args': 's=UIScrollView' })
                await ipc.request('nb_call_main_thread', { object: 'temp', method: 'initWithFrame:', target: 'scroll', 'args': 'rect={{0, 0}, {500, 500}}' })
                //await ipc.request('nb_call_main_thread', { object: 'nb', method: 'setProperty:propertyName:value:', 'args': 'o=scroll|s=backgroundColor|o=redColor' })
                await ipc.request('nb_call_main_thread', { object: 'mainView', method: 'addSubview:', 'args': 'o=scroll' })
                //await ipc.request('nb_call_main_thread', { object: 'mainView', method: 'insertSubview:belowSubview:', 'args': 'o=scroll|o=webView' })
                await ipc.request('nb_call_main_thread', { object: 'mainView', method: 'sendSubviewToBack:', 'args': 'o=scroll' })
                //await ipc.request('nb_call_main_thread', { object: 'nb', method: 'createObj:', target: 'playerFactory', 'args': 's=main.ViewFactory' })
                await ipc.request('nb_call_main_thread', { object: 'nb', method: 'createBlockData:eventId:', target: 'dvrip_logger', 'args': 's=player.log|s=dvrip_logger' })
                await ipc.request('dvrip', { type: 'registerLogger', fnObject: 'dvrip_logger' })

                const currentWindow = await window['_modules'].application.getCurrentWindow()
                currentWindow.setBackgroundColor({ red: 10, green: 10, blue: 1, alpha: 0 })
                currentWindow.on('player.log', (a) => {
                    console.log('player log', a.detail)
                })
                currentWindow.on('player.event', event => {
                    console.log('player event', event)
                    try {
                        const json = JSON.parse(event.detail.message)
                        json.arguments.id = event.detail.id
                        this._onNativeEvent(json.method, json.arguments)
                    } catch(e) {
                        console.log(e)
                    }
                })

                const self = this
                document.addEventListener('visibilitychange', function() {
                    if (document.hidden) {
                        self.app.emit('onSuspend')
                    } else {
                        self.app.emit('onResume')
                    }
                });
            }

            Alpine.store('state', { 
                cinemaItems: Alpine.$persist([]).as('state_cinema_items'),
                settings: Alpine.$persist({
                    mainScreen: 'devices'
                }).as('state_settings'),
                devices: Alpine.$persist(null).as('state_devices')
            })
            Alpine.effect(() => {
                const devices = Alpine.store('state').devices
                if (devices == null) {
                    devicesById = {}
                    camerasById = {}
                } else {
                    devices.forEach(device => {
                        devicesById[device.id] = device
                        device.cameras.forEach(camera => {
                            camerasById[camera.id] = camera
                        })
                    })
                }
            })
            this.setOrientation()
            if (window.webkit) {
                //const origLog = console.log
                //const self = this
                //console.origLog = origLog
                //console.log = function () {
                //    origLog(...arguments)
                    //self.callIOS('log', ...arguments)
                //}
            } else {
                this.app.videoGridMock = videoGridMockComponent()
            }

            window.addEventListener("orientationchange", () => {
                var mql = window.matchMedia("(orientation: portrait)")

                if (mql.matches) {
                    this.app.orientation = 'portrait';
                } else {
                    this.app.orientation = 'landscape';
                }
                this.updateSafeArea()
            })

            this.updateSafeArea()

            this.app.on('onSuspend', _ => {
                const pages = this.app.pages
                if (pages.length > 0) {
                    const lastPage = pages[pages.length - 1]
                    if (lastPage.deactivating) lastPage.deactivating()
                }
            })

            this.app.on('onResume', _ => {
                const pages = this.app.pages
                if (pages.length > 0) {
                    const lastPage = pages[pages.length - 1]
                    if (lastPage.activating) lastPage.activating()
                }
            })

            try {
                await fapp.reAuthenticate()
            } catch (e) {
                this.app.goPage('login', true)
                console.log(e)
            }

            window.addEventListener("unload", (event) => {
                for (let i=0; i<32; i++) {
                    //await this.callIOS('removePlayer', {id: i})
                }
                //if (ipc) ipc.request('nb_call_main_thread', { object: 'scroll', method: 'removeFromSuperview', 'args': '' })
            })
        },
        onLogin({ user, accessToken }) {
            try {
                ym(97562490, 'userParams', {
                    UserID: user.id
                })
            } catch (e) {
                console.log(e)
            }
            this.app.user = user
            //this.app.token = accessToken
            this.app.isLogin = true
            //this.callIOS('setToken', accessToken)
            let mainScreen = this.$store.state.settings.mainScreen
            if (!pages[mainScreen]) mainScreen = 'devices'
            this.app.goPage(mainScreen, true)
        },
        onLogout() {
            this.app.isLogin = false
            this.app.goPage('login', true)
            localStorage.removeItem('token')
            localStorage.removeItem('devices')
            this.app.user = null
            //this.callIOS('setToken', null)
        },
        async updateSafeArea() {
            this.app.safeArea = await this.callIOS('sizeInfo')
            await this.callIOS('setWebViewParams', {
                params: [
                    ['top', -this.app.safeArea.top],
                    ['height', this.app.safeArea.height],
                    ['left', -this.app.safeArea.left],
                    ['width', this.app.safeArea.width]
                ]
            })
            this.callIOS('setScrollParams', {
                params: [
                    //['backgroundColor', 'black'],
                    ['top', this.app.orientation == 'portrait' ? 56 : 0],
                    ['height', this.app.safeArea.height],
                    ['left', -this.app.safeArea.left],
                    ['width', this.app.safeArea.width]
                ]
            })

            document.body.style.setProperty("--safe-area-inset-top", this.app.safeArea.top + "px")
            document.body.style.setProperty("--safe-area-inset-bottom", this.app.safeArea.bottom + "px")
            document.body.style.setProperty("--safe-area-inset-left", this.app.safeArea.left + "px")
            document.body.style.setProperty("--safe-area-inset-right", this.app.safeArea.right + "px")
        },
        async test() {
            if (!this.isConnected) {
                this.isConnected = true
                console.log('Attempt connect to dvrip!!!!!!!!!!!')
                this.connectDvrip()
            }
            const resp = await this.dvripCallback()
            this.list = resp.OPFileQuery
            try {
                console.log('before parse')
            } catch (e) {
                console.log('error parse')
                console.log(e.message)
            }
        },
        callIOS(eventName, data) {
            //if (eventName != 'log') console.log(eventName, data)
            if (!window.webkit) {
                console.log('mockCallIOS', eventName, data)
                let answ = {}
                switch (eventName) {
                    case 'sizeInfo':
                        return {
                            top: 10,
                            left: 0,
                            bottom: 10,
                            right: 0,
                            height: window.screen.height,
                            width: window.screen.width
                        }
                    case 'dvripCallback':
                        answ = JSON.stringify({
                            OPFileQuery: [{
                                BeginTime: dayjs().subtract(10, 'hour').format('YYYY-MM-DD HH:mm:ss'),
                                EndTime: dayjs().format('YYYY-MM-DD HH:mm:ss')
                            }]
                        }) + "\n"
                        break
                    case 'addPlayer':
                        answ = this.app.videoGridMock.addPlayer(data)
                        break
                    case 'setPlayerParams':
                        answ = this.app.videoGridMock.setPlayerParams(data)
                        break
                    case 'startPlayer':
                        answ = this.app.videoGridMock.startPlayer(data)
                        break
                    case 'setScrollParams':
                        answ = this.app.videoGridMock.setScrollParams(data)
                        break
                    case 'setCamGridParams':
                        answ = this.app.videoGridMock.setCamGridParams(data)
                        break
                    case 'removePlayer':
                        answ = this.app.videoGridMock.removePlayer(data)
                        break
                    case 'stopPlayer':
                        answ = this.app.videoGridMock.stopPlayer(data)
                        break
                    case 'confirm':
                        answ = confirm(data.message)
                        break
                }
                return new Promise((resolve, reject) => {
                    resolve(answ)
                })
            }
            
            return new Promise(async (resolve, reject) => {
                /*if (window) {
                    return resolve('camera')
                }*/
                const cbi = ++cbIndex
                callbacks[cbi] = {
                    resolve,
                    reject
                }
                //this._iosResponseMap[++this._iosCntResponseId] = data;
                var metadata = { eventName: eventName, i: cbi, data };
                if (
                    window.webkit &&
                    window.webkit.messageHandlers.IOS &&
                    window.webkit.messageHandlers.IOS.postMessage
                ) {
                    window.webkit.messageHandlers.IOS.postMessage(JSON.stringify(metadata));
                } else {
                    //console.origLog(metadata)
                    switch (eventName) {
                        case 'info':
                            await ipc.request('nb_call_main_thread', { object: 'nb', method: 'createClass:', target: 'bundle', 'args': 's=NSBundle' })
                            const res10 = (await ipc.request('nb_call_main_thread', { object: 'nb', method: 'getPropertyDeep:propertyName:', remove: 'bundle', 'args': 'o=bundle|s=mainBundle.infoDictionary.CFBundleVersion' }))
                            return resolve({bundle: res10.data})
                        case 'sizeInfo':
                            const res = await ipc.request('nb_call_main_thread', { object: 'nb', method: 'getProperty:propertyName:', 'args': 'o=window|s=safeAreaInsets' })
                            const safeArea = parseStringToObject(res.data)

                            return resolve({
                                top: safeArea.top,
                                left: safeArea.left,
                                bottom: safeArea.bottom,
                                right: safeArea.right,
                                height: window.screen.height,
                                width: window.screen.width
                            })
                        case 'setCamGridParams':
                            return resolve({})
                        case 'setWebViewParams':
                            for (let i = 0; i< data.params.length; i++) {
                                let item = data.params[i]
                                switch(item[0]) {
                                    case 'opacity':
                                        await ipc.request('nb_call_main_thread', { object: 'webView', method: 'setAlpha:', 'args': 'f='+item[1] })
                                        break
                                }
                            }
                            //const frame = await ipc.request('nb_call_main_thread', { object: 'nb', method: 'getProperty:propertyName:', 'args': 'o=webView|s=frame' })
                            //console.origLog(res2.data)
                            return resolve({})
                        case 'setScrollParams':
                            const sizeScroll = [0,0,500,500]
                            let setSizeScroll = false
                            for (let i = 0; i< data.params.length; i++) {
                                let item = data.params[i]
                                switch(item[0]) {
                                    case 'left':
                                        sizeScroll[0] = item[1]
                                        setSizeScroll = true
                                        break
                                    case 'top':
                                        sizeScroll[1] = item[1] + (this.app ? this.app.safeArea.top : this.safeArea.top)
                                        setSizeScroll = true
                                        break
                                    case 'width':
                                        sizeScroll[2] = item[1]
                                        setSizeScroll = true
                                        break
                                    case 'height':
                                        sizeScroll[3] = item[1]
                                        setSizeScroll = true
                                        break
                                }
                            }
                            if (setSizeScroll) {
                                let rect = '{{'+sizeScroll[0]+', '+sizeScroll[1]+'}, {'+sizeScroll[2]+', '+sizeScroll[3]+'}}'
                                await ipc.request('nb_call_main_thread', { object: 'nb', method: 'setProperty:propertyName:value:', 'args': 'o=scroll|s=frame|nrect='+rect })
                            }
                            return resolve({})
                        case 'setPlayerParams':
                            const resPlayerSize = await ipc.request('nb_call_main_thread', { object: 'nb', method: 'getProperty:propertyName:', 'args': 'o=player'+data.id+'View|s=frame' })
                            const playerSize = parseStringToObject(resPlayerSize.data)
                            if (playerSize == null) return resolve({})
                            const size = [playerSize.x,playerSize.y,playerSize.width,playerSize.height]
                            console.log('old size '+data.id, JSON.stringify(size))
                            console.log('params '+data.id, JSON.stringify(data.params))
                            let setSize = false
                            for (let i = 0; i< data.params.length; i++) {
                                let item = data.params[i]
                                switch(item[0]) {
                                    case 'left':
                                        size[0] = item[1]
                                        setSize = true
                                        break
                                    case 'top':
                                        size[1] = item[1]
                                        setSize = true
                                        break
                                    case 'width':
                                        size[2] = item[1]
                                        setSize = true
                                        break
                                    case 'height':
                                        size[3] = item[1]
                                        setSize = true
                                        break
                                }
                            }
                            if (setSize) {
                                let rect = '{{'+size[0]+', '+size[1]+'}, {'+size[2]+', '+size[3]+'}}'
                                console.log('new size'+ data.id, rect)
                                await ipc.request('nb_call_main_thread', { object: 'nb', method: 'setProperty:propertyName:value:', 'args': 'o=player'+data.id+'View|s=frame|nrect='+rect })
                            }
                            let color = 'blackColor'
                            /*let color = 'redColor'
                            if (data.id == 1) {
                                color = 'greenColor'
                            } else if (data.id == 2) {
                                color = 'yellowColor'
                            }*/
                            if (data.className !="")await ipc.request('nb_call_main_thread', { object: 'nb', method: 'setProperty:propertyName:value:', 'args': 'o=player'+data.id+'View|s=backgroundColor|o='+color })
                            return resolve({})
                        case 'getContext':
                            const path = window['_modules'].path.DOCUMENTS+'/app/media'
                            await window['_modules'].fs.mkdir(path, {recursive: true}).catch(e => console.log(e))
                            return resolve({
                                path
                            })
                        case 'setScrollOffset':
                            ipc.request('nb_call_main_thread', { object: 'scroll', method: 'setContentOffset:', 'args': 'point={'+data+',0}' })
                            return resolve({})
                        case 'addPlayer':
                            const objName = 'player'+data.id
                            await ipc.request('nb_call_main_thread', { object: 'nb', method: 'createBlockEvent:eventId:', target: objName+'block_log', 'args': 's=player.log|s='+data.id })
                            await ipc.request('nb_call_main_thread', { object: 'nb', method: 'createBlockEvent:eventId:', target: objName+'block_event', 'args': 's=player.event|s='+data.id })
                            await ipc.request('nb_call_main_thread', { object: 'nb', method: 'createObj:', target: objName+'Controller', 'args': 's=PlayerController' })
                            await ipc.request('nb_call_main_thread', { object: objName+'Controller', method: 'initWithFrame:', target: objName, 'args': 'rect={{0,0}, {100, 100}}' })
                            await ipc.request('nb_call_main_thread', { object: 'nb', method: 'createBlockStream:', target: objName+'block_stream', 'args': 's='+ objName+'Controller'})
                            await ipc.request('nb_call_main_thread', { object: objName, method: 'setLogFunc:', 'args': 'o='+objName+'block_log' })
                            await ipc.request('nb_call_main_thread', { object: objName, method: 'setCbFunc:', 'args': 'o='+objName+'block_event' })
                            await ipc.request('nb_call_main_thread', { object: objName, method: 'getView', target: objName+'View', 'args': '' })
                            await ipc.request('nb_call_main_thread', { object: 'scroll', method: 'addSubview:', 'args': 'o='+objName+'View' })
                            return resolve({})
                        case 'removePlayer':
                            const objName2 = 'player'+data.id
                            await ipc.request('nb_call_main_thread', { object: 'player'+data.id, method: 'callWithRequest:', remove: objName2+'Controller', 'args': 'dict=' + JSON.stringify({
                                method: 'destroy'})})
                            await ipc.request('nb_call_main_thread', { object: 'nb', method: 'log:', remove: objName2+'block_log', 'args': 's=remove'})
                            await ipc.request('nb_call_main_thread', { object: 'nb', method: 'log:', remove: objName2+'block_event', 'args': 's=remove'})
                            await ipc.request('nb_call_main_thread', { object: 'nb', method: 'log:', remove: objName2+'View', 'args': 's=remove'})
                            await ipc.request('nb_call_main_thread', { object: 'nb', method: 'log:', remove: objName2, 'args': 's=remove'})
                            console.log(await ipc.request('nb_call_main_thread', { object: 'nb', method: 'dumpObjects', 'args': ''}))
                            return resolve({})
                        case 'playerScreenshot':
                            const resp6 = await ipc.request('nb_call_main_thread', { object: 'player'+data.id, method: 'callWithRequest:', 'args': 'dict=' + JSON.stringify({
                                method: 'screenshot', filename: data.path})})
                            return resolve(resp6.data.string)
                        case 'keepScreenAwake':
                            await ipc.request('nb_call_main_thread', { object: 'nb', method: 'setProperty:propertyName:value:', 'args': 'o=app|s=idleTimerDisabled|s=YES' })
                            return resolve({})
                        case 'allowSleepAgain':
                            await ipc.request('nb_call_main_thread', { object: 'nb', method: 'setProperty:propertyName:value:', 'args': 'o=app|s=idleTimerDisabled|s=NO' })
                            return resolve({})
                        case 'dvripNew':
                            //return
                            await ipc.request('dvrip', {
                                type: 'newDeviceSession', saveObject: 'dvripsession'+data.id, string: JSON.stringify({
                                    serverURI: data.serverURI,
                                    deviceID: data.deviceID
                                })
                            })
                            return resolve({})
                        case 'dvripCallback':
                            let req = '{"code": '+data.code+', "channel": 0, "body": ' + JSON.stringify(JSON.stringify(data.body)) + '}'
                            const resp = await ipc.request('dvrip', { type: 'callback', useObject: 'dvripsession'+data.id, string: req })
                            return resolve(resp.data.string)
                        case 'dvripCall':
                            let req2 = '{"code": '+data.code+', "channel": 0, "body": ' + JSON.stringify(JSON.stringify(data.body)) + '}'
                            const resp2 = await ipc.request('dvrip', { type: 'call', useObject: 'dvripsession'+data.id, string: req2 })
                            return resolve(resp2.data.string)
                        case 'startStream':
                            const resp3 = await ipc.request('dvrip', { type: 'stream', useObject: 'dvripsession'+data.id, fnObject: 'player'+data.id+'block_stream', string: JSON.stringify({
                                path: data.filename
                            })})
                            return resolve(resp3.data.string)
                        case 'startPlayer':
                            await ipc.request('nb_call_main_thread', { object: 'player'+data.id, method: 'callWithRequest:', 'args': 'dict=' + JSON.stringify({
                                method: 'init', request: JSON.stringify({
                                    filename: data.filename,
                                    formatOpts: data.formatOpts
                                }) })})
                            const resp4 = await ipc.request('nb_call_main_thread', { object: 'player'+data.id, method: 'callWithRequest:', 'args': 'dict=' + JSON.stringify({
                                method: 'play', request: '{}' })})
                            return resolve(resp4.data.string)
                        case 'stopPlayer':
                            const resp5 = await ipc.request('nb_call_main_thread', { object: 'player'+data.id, method: 'callWithRequest:', 'args': 'dict=' + JSON.stringify({
                                method: 'stop', request: '{}' })})
                            await ipc.request('nb_call_main_thread', { object: 'nb', method: 'log:', remove: 'dvripsession'+data.id, 'args': 's=remove_dvripsession'})
                            return resolve(resp5.data.string)
                        case 'playAudio':
                            await ipc.request('nb_call_main_thread', { object: 'player'+data.id, method: 'callWithRequest:', 'args': 'dict=' + JSON.stringify({
                                method: 'playAudio', request: '{"value":'+data.value+'}' })})
                            return resolve()
                    }
                    /*

                    

    await ipc.request('nb_call_main_thread', { object: 'player', method: 'callWithRequest:', 'args': 'dict=' + JSON.stringify({
        method: 'init', request: JSON.stringify({
            filename: '/Users/jeny/test/a/1.h264',
            formatOpts: {probesize: "32"}
        }) })})


                    this.callJs('cb', { i: msg.i, data: {
                            width: Screen.mainScreen.widthDIPs,
                            height: Screen.mainScreen.heightDIPs,
                            top: Application.ios.window.safeAreaInsets.top,
                            bottom: Application.ios.window.safeAreaInsets.bottom,
                            left: Application.ios.window.safeAreaInsets.left,
                            right: Application.ios.window.safeAreaInsets.right
                        } })
                    */
                }
            })
        },
        _onNativeEvent(event, data) {
            console.log('_onNativeEvent', event, data)
            switch (event) {
                case 'cb':
                    const cbi = data.i
                    if (callbacks[cbi]) {
                        if (data.e) {
                            callbacks[cbi].reject(new Error(data.e))
                        } else {
                            callbacks[cbi].resolve(data.data)
                        }
                        delete (callbacks[cbi])
                    }
                    break
                default:
                    this.app.emit(event, data)
            }
            return true
        },
        async connectDvrip(id, { serverURI, deviceID }) {
            await this.callIOS('dvripNew', {
                id,
                serverURI,
                deviceID,
                //deviceID: '70D1whu3vE',
            })
            console.log('dvrip connected!!!')
        },
        setOrientation() {
            var mql = window.matchMedia("(orientation: portrait)");

            if (mql.matches) {
                this.app.orientation = 'portrait'
            } else {
                this.app.orientation = 'landscape'
            }

            const self = this

            // Add a media query change listener
            mql.addEventListener('change', function (m) {
                if (m.matches) {
                    self.app.orientation = 'portrait'
                    self.app.emit('orientation', 'portrait')
                }
                else {
                    self.app.orientation = 'landscape'
                    self.app.emit('orientation', 'landscape')
                }
                self.updateSafeArea()
            });
        }
    }
}

document.addEventListener('alpine:init', () => {
    Alpine.data('root', root)
    Alpine.store("message", {
        items: [],
        show(text, type = 'success') {
            this.add(text, type)
        },
        success(text) {
            this.add(text)
        },
        error(text) {
            this.add(text, 'error')
        },
        add(text, type = 'success') {
            let message = Alpine.reactive({
                text,
                type,
                timer: setTimeout(() => {
                    this.remove(message)
                }, 3000)
            })
            this.items.push(message)
        },
        remove(message) {
            clearTimeout(message.timer)
            this.items = this.items.filter(m => m != message)
        }
    })
})
